<template>
  <div class="industrydata">
    <div class="itemtop">
      <h3>产品展示</h3>
      <router-link :to="`/news/views/${plateIdInfo}`">更多</router-link>
    </div>
    <ul class="itembottom">
      <router-link class="itemone" v-for="item in infos" :key="item.id" :to="`/news/info/${item.plateid}/${item.uuid}`" tag="li">
        <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="204" height="156" alt="">
        <h4>{{item.title}}</h4>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import {getNewsViews} from '@/request/get'
export default {
  name: "Interaction",
  data(){
    return {
      infos: [],
      IP_TEST,
      plateIdInfo:""
    }
  },
  created() {
     this.changeInfo(0,'产品展示');
  },
  methods: {
   async getNewsViews(uuid) {
      let result = await getNewsViews(uuid, 1,10);
      result = result.data;
      this.infos = result || [];
    },
    changeInfo(index, name) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      this.getNewsViews(this.plateIdInfo);
    },
  }
};
</script>
<style scoped>
.industrydata {
  position: relative;
  margin-top: 20px;
  width: 1300px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
}

.industrydata>.itemtop {
  width: 100%;
  height: 42px;
  padding-left: 43px;
  background: url(/static/img/b2.png) no-repeat;
  background-size: 375px 43px;
  border-bottom: 1px solid #E7E7E7;
  margin-bottom:10px;
}

.industrydata>.itemtop>h3 {
  height: 42px;
  font-size: 24px;

  font-weight: bold;
  color: #1C4D5A;
  line-height: 44px;
}

.industrydata>.itemtop::before {
  content: '';
  position: absolute;
  top: 11px;
  left: 11px;
  width: 22px;
  height: 22px;
  background: url(/static/img/icon_fuwu.png);
  background-size: 22px 22px;
}
.industrydata>.itembottom{
  padding-left: 4px;
  height: 196px;
  display: flex;
  justify-content: space-between;
}
.industrydata>.itembottom>.itemone{
  width: 268px;
  height: 194px;
  border: 1px solid #ECECEC;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items:center;
}
.industrydata>.itembottom>.itemone>img{
  margin: 8px 0 8px;
}
.industrydata>.itembottom>.itemone>h4{
  height: 16px;
  font-size: 14px;

  font-weight: 500;
  color: #333333;
  line-height: 16px;
}
</style>
